import { ref } from "vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { DataLayer } from "@sazka/utils/data-layer";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { useLocalStorage } from "@sazka/utils/use-storage";
import { Questionnaire } from "./model/questionnaire";

const storage = useLocalStorage();
const storageName = "question-history";

export const isQuestionnaireOpen = ref(false);

export async function useQuestionnaires() {
    if (
        !environment.nodeAliasPath ||
        environment.nodeAliasPath.indexOf("kontrola-sazky") >= 0 ||
        environment.nodeAliasPath.indexOf("vsadit-si-online") >= 0
    )
        return;

    await ngFrameworkLoaded();

    ng_hs.depositSucceeded(async () => {
        let hasClosedConfirmation = false;

        ng_hs.onStateChange(async (ngState) => {
            if (ngState === "idle" && !hasClosedConfirmation) {
                hasClosedConfirmation = true;
                await useQuestionnairesOnDeposit();
            }
        });
    });

    setTimeout(async () => {
        await callQuestionnaire();
    }, 2000);
}

export async function useQuestionnairesOnOnlineBet(lottery: Lottery) {
    await callQuestionnaire("online-bet", lottery);
}

export async function useQuestionnairesOnTicketCheck(lottery: Lottery) {
    await callQuestionnaire("bet-check", lottery);
}

async function useQuestionnairesOnDeposit() {
    await callQuestionnaire("deposit");
}

async function callQuestionnaire(type?: string, lottery?: Lottery) {
    if (isQuestionnaireOpen.value) {
        return;
    }

    let endpoint = "";
    if (type) {
        endpoint = type;
        if (lottery) {
            endpoint += `/${lottery}`;
        }
    } else {
        endpoint = `active?nodeAliasPath=${window.environment.nodeAliasPath}`;
    }

    try {
        const questionnaires = await httpClient.get<Questionnaire[]>(`/api/questionnaire/${endpoint}`);
        if (!questionnaires.data?.length) return;

        const seenQuestionnaires = storage.getJson<number[]>(storageName) ?? [];
        const questionnaireToShow = questionnaires.data.find((d) => !seenQuestionnaires?.includes(d.id));

        if (questionnaireToShow) {
            isQuestionnaireOpen.value = true;
            seenQuestionnaires.push(questionnaireToShow.id);
            storage.setJson(storageName, seenQuestionnaires, "essential");
            (await import("./mount-questionnaire")).mount({ questionnaire: questionnaireToShow, placement: type });
        }
    } catch {}
}

export enum ActionType {
    VIEW = "view",
    CLOSE = "close",
    COMPLETE = "complete",
}

export function dataLayer(type: string, action: ActionType): void {
    DataLayer.push({
        event: `action.${action}.${type}`,
    });
}
